function getColorBrightness(rgbColor) {
  var colorValues = rgbColor.match(/[\d\.]+/g).map(Number);
  return 0.2126 * (colorValues[0] / 255) + 0.7152 * (colorValues[1] / 255) + 0.0722 * (colorValues[2] / 255);
}

function isSimilarToBackground(color) {
  var backgroundColor = 'rgb(255, 255, 255)';

  var colorBrightness = getColorBrightness(color);
  var backgroundColorBrightness = getColorBrightness(backgroundColor);

  return (backgroundColorBrightness / colorBrightness) < 1.5;
}

var SwatchColors = (function() {
  function SwatchColors() {
    this.colors = {};

    this.images = {'mdf-madera': 'url("//fotocanvas.com.ve/cdn/shop/files/MDF_120x.jpg?v=14354489671514407447")','lienzo-algodon-con-bastidor': 'url("//fotocanvas.com.ve/cdn/shop/files/LIENZO-ALGODON_120x.jpg?v=5731662406998364697")','lienzo-poliester-con-bastidor': 'url("//fotocanvas.com.ve/cdn/shop/files/LIENZO-POLIESTER_120x.jpg?v=8427535972289503788")','lienzo-algodon-sin-bastidor': 'url("//fotocanvas.com.ve/cdn/shop/files/LIENZO-ENROLLADO_120x.jpg?v=16890956739052687140")','acrilico-3mm': 'url("//fotocanvas.com.ve/cdn/shop/files/ACRILICO-3MM_120x.jpg?v=11571662117992894439")','acrilico-5mm': 'url("//fotocanvas.com.ve/cdn/shop/files/ACRILICO-5MM_120x.jpg?v=2214418609740445970")','sin-canuela-o-marco': 'url("//fotocanvas.com.ve/cdn/shop/files/LIENZO-ALGODON_120x.jpg?v=5731662406998364697")','caja-americana': 'url("//fotocanvas.com.ve/cdn/shop/files/LIENZO-CON-CAJA-AMERICANA_120x.jpg?v=13989416617234467438")','caja-americana-delgada': 'url("//fotocanvas.com.ve/cdn/shop/files/LIENZO-CON-CAJA-AMERICANA-DELGADA_120x.jpg?v=6454184750445986547")','caja': 'url("//fotocanvas.com.ve/cdn/shop/files/LIENZO-CON-CAJA_120x.jpg?v=14123007657239406853")','museo-con-pestana': 'url("//fotocanvas.com.ve/cdn/shop/files/LIENZO-CON-MUSEO_120x.jpg?v=4754252210964742183")',};

    this.triggers = ['color','colour','couleur','farbe','cor','material','montura',];
  }

  function setSwatchColor(swatch) {
    var swatchId = swatch.getAttribute('swatch-id');

    if (Object.keys(this.colors).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.colors[swatchId]);

      if (isSimilarToBackground(this.colors[swatchId])) swatch.classList.add('is-similar-to-background');
      if (getColorBrightness(this.colors[swatchId]) > 0.5) {
        swatch.style.setProperty('--tick-color', '#000');
      } else {
        swatch.style.setProperty('--tick-color', '#fff');
      }
      swatch.classList.remove('is-blank');
    }

    if (Object.keys(this.images).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.images[swatchId]);
      swatch.classList.add('is-image');
      swatch.classList.remove('is-blank');
    }
  }
  SwatchColors.prototype.setSwatchColor = setSwatchColor;

  return SwatchColors;
}());

const Swatches = new SwatchColors();

function VariantSwatch() {
  return Reflect.construct(HTMLElement, [], this.constructor);
}

VariantSwatch.prototype = Object.create(HTMLElement.prototype);
VariantSwatch.prototype.constructor = VariantSwatch;
Object.setPrototypeOf(VariantSwatch, HTMLElement);

VariantSwatch.prototype.connectedCallback = function() {
  Swatches.setSwatchColor(this);
};
customElements.define('variant-swatch', VariantSwatch);

export default Swatches;
